export default "__VITE_ASSET__B42I0FZU__"